import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const ForwardButton = ({ shouldDisplayForwardButton, isVOD, translate, forwardButtonHandler, spinnerToggle }) => {
  const theme = useTheme();
  if (!shouldDisplayForwardButton) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={
        isVOD
          ? process.env.PUBLIC_URL + "/images/playback-skip-forward-10.svg"
          : process.env.PUBLIC_URL + "/images/playback-skip-forward-30.svg"
      }
      alt={translate("forward")}
      className="playbackButton"
      onClickHandler={forwardButtonHandler}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default ForwardButton;
